export default __webpack_public_path__ + "static/launched-b221463ed064d80a434997dbcd4ddc50.png";